import { Space } from '@mantine/core';
import { useParams } from 'react-router-dom';

import { Funnels } from '../components/Funnels';
import { Managers } from '../components/Managers';
import { UrlPlatform } from '../types';

import { SectionDivider } from '@/components/Layout/SectionDivider';
import { convertToCamelCase } from '@/utils';

type Props = {
  platform: UrlPlatform;
};

export const Page = ({ platform }: Props) => {
  const { id = '' } = useParams<{ id: string }>();

  return (
    <div>
      <SectionDivider label="Funnel" />
      <Funnels pageId={id} />
      <Space h="xl" />
      <SectionDivider label="Managers" />
      <Managers pageId={id} platform={convertToCamelCase(platform)} />
    </div>
  );
};
